/// <reference path="Definitions/google.maps.d.ts" />
/// <reference path="Definitions/underscore.d.ts" />

import * as $ajax from './_ajax'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import { propertyform as $propertyform } from './search'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    tempFlagId: string
    prefix: string
}

let options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    $helpers.partialPageInit($('.' + options.pageName + ''))

    $('.' + options.pagePrefix + '-flags .bcfla-label').click(function () {
        $(this).toggleClass('bcfla-label-unchecked')
        $(this).toggleClass('bcfla-checked')
    })

    $('.' + options.pagePrefix + '-btn-save').click(function () {
        var names = []
        var ids = []
        $('.' + options.pagePrefix + '-table-name').each(function () {
            var icon = $(this).attr('data-include') == '+' ? 'plus' : 'minus'
            names.push('<span class="fas fa-' + icon + '-circle"></span> ' + $(this).html())

            ids.push($(this).attr('data-include') + $(this).attr('data-id'))
        })

        console.log(names)
        console.log(ids)

        $propertyform.setTempflagId(options.prefix, options.tempFlagId, names, ids)
        $modal.hide()
    })

    $('.' + options.pagePrefix + '-btn-close').click($modal.hide)

    $('.' + options.pagePrefix + '-btn-include').click(function () {
        addFlags(true)
    })
    $('.' + options.pagePrefix + '-btn-exclude').click(function () {
        addFlags(false)
    })

    $('.' + options.pagePrefix + '-table-delete').click(function () {
        $modal.load('/Flag/SearchPropertyTempflagModal', { delete: $(this).attr('data-id'), prefix: options.prefix }, false, true, false)
    })

    function addFlags(add: boolean) {
        var vals = []
        $('.' + options.pagePrefix + '-flags .bcfla-checked').each(function () {
            vals.push($(this).attr('data-value'))
        })

        if (add) $modal.load('/Flag/SearchPropertyTempflagModal', { include: vals.join(','), prefix: options.prefix }, false, true, false)
        else $modal.load('/Flag/SearchPropertyTempflagModal', { exclude: vals.join(','), prefix: options.prefix }, false, true, false)

        $('.' + options.pagePrefix + '-flags .bcfla-label').addClass('bcfla-label-unchecked')
        $('.' + options.pagePrefix + '-flags .bcfla-label').removeClass('bcfla-checked')
    }
}
